@if (formGroup) {
  <form id="items" [formGroup]="formGroup">
    @if (lines.length) {
      <table style="width: 100%; table-layout: auto">
        <tr class="tablerow">
          <th class="colseq">#</th>
          <th class="colid">Id</th>
          <th class="colbc">Cond.</th>
          <th class="colproductname">Produit</th>
          <th class="colsaleunit">Unité de Vente</th>
          <th class="colqty">Qté</th>
          <th class="colcol">Col.</th>
          <th class="colup" [class.ht-background]="is_ht" [class.ttc-background]="!is_ht">
            <div [class.ht-text]="is_ht" [class.ttc-text]="!is_ht">{{ is_ht ? 'Px HT' : 'Px TTC' }}</div>
            <div>Catal.</div>
            <div>du cond.</div>
          </th>
          <th class="colflatdiscount" [class.ht-background]="is_ht" [class.ttc-background]="!is_ht">
            <div>Rem.</div>
            <div [class.text-error]="is_ht" [class.text-success]="!is_ht">{{ is_ht ? 'HT €' : 'TTC €' }}</div>
          </th>
          <th class="colpercentdiscount">
            <div>Rem.</div>
            <div>%</div>
          </th>
          <th class="colnetprice" [class.ht-background]="is_ht" [class.ttc-background]="!is_ht">
            <div>Net</div>
            <div>du cond.</div>
            <div [class.text-error]="is_ht" [class.text-success]="!is_ht">{{ is_ht ? 'HT €' : 'TTC €' }}</div>
          </th>
          <th class="colcolnetprice" [class.ht-background]="is_ht" [class.ttc-background]="!is_ht">
            <div>Net / unité</div>
            <div [class.text-error]="is_ht" [class.text-success]="!is_ht">{{ is_ht ? 'HT €' : 'TTC €' }}</div>
          </th>
          <th class="colvat">TVA</th>
          <th class="colamounttaxx ht-background ht-text">Mnt HT</th>
          <th class="colamounttaxi ttc-background ttc-text">Mnt TTC €</th>
          <th class="coldelete"></th>
          <!-- <th class="bidon">salut bidon</th> -->
          <!-- <th class="col7">&nbsp;</th> -->
        </tr>
        <ng-container formArrayName="lines">
          <!-- cette classe pour la parité n est plus utilise   .parity_table_line:nth-child(odd) { background-color: map.get( theme-colors.$primary-palette,98) } -->
          @for (line of lines.controls; track line; let i = $index) {
            @if (is_line_visible(line)) {
              <tbody class="tablerow" (keydown)="onLineKeydown($event, i)" [class]="is_configurable_line($any(line)) ? 'configurable_product_line' : $any(line).value.typ === OrderLineType.COMPONENT ? 'component_child_line' : $any(line).value.typ === OrderLineType.ITEM_RETURN ? 'return_line' : 'normal_line'" [class.line-highlight]="line.get('_highlight')?.value === true">
                <tr>
                  <td class="colseq" rowspan="2">
                    {{ line.value.seq }}
                  </td>
                  <td class="colid" rowspan="2">
                    {{ line.value.product }}
                  </td>
                  <td class="colbc" rowspan="2">
                    {{ line.value.ppv }}
                  </td>
                  <td class="colproductname flexcol" rowspan="2">
                    <!-- name  warning si le produit est is_sold false -->
                    <div class="flexcol">
                      <div class="flexrow" style="justify-content: center">
                        <!-- Garde d'état ajoutée : le dialogue de configuration réécrit les lignes
                        enfants ; il n'a rien à faire sur un document qui n'est plus en création. -->
                        @if (is_configurable_line($any(line)) && isLineEditable) {
                          <button mat-icon-button color="primary" matTooltip="Configurer" aria-label="Configurer" (click)="onConfiguration(line)" style="margin-right: 6px"><mat-icon style="font-size: 15px">settings</mat-icon></button>
                        }
                        @if ($any(line).value.typ === OrderLineType.ITEM_RETURN) {
                          <span class="badge-return">RETOUR</span>
                        }
                        <!-- Nouvel onglet : la commande en cours reste dans celui-ci (JP, 26/10). -->
                        <a class="primary" [routerLink]="['/sales/product', line.value.product]" target="_blank">{{ line.value.product_name }}</a>
                      </div>
                      @if (udiLabel(line)) {
                        <div class="udi-line" [matTooltip]="line.value.data?.udi?.raw ?? ''">{{ udiLabel(line) }}</div>
                      }
                      @if (is_configurable_line($any(line))) {
                        <div class="config-block">
                          <div class="config-title">
                            {{ line.value.data.cufs[C_CUF_CONFIGURATION].split('.').pop() }}
                          </div>
                          @for (conf of line.value.data.cufs[C_CUF_CONFIGURATION_VALUE]; track conf) {
                            <div class="config-item">
                              {{ conf.order_node_name }}
                            </div>
                          }
                        </div>
                      }
                      <!-- Mémo de ligne (sales_order_l.memo), comme en location ; pas sur un COMPONENT, que la F3 montre aussi dans rentgeneral. Entrée y fait un saut de ligne : arrêtée avant onLineKeydown (preventDefault). -->
                      @if (isLineEditable && $any(line).value.typ !== OrderLineType.COMPONENT) {
                        <textarea class="line-memo-input" cdkTextareaAutosize cdkAutosizeMinRows="1" aria-label="Mémo de la ligne" placeholder="Mémo (imprimé sur toutes les pièces)" [formControl]="$any(line.get('memo'))" (blur)="trimMemo(line)" (keydown.enter)="$event.stopPropagation()" (keydown.shift.enter)="$event.stopPropagation()"></textarea>
                      } @else if (line.value.memo) {
                        <div class="line-memo">{{ line.value.memo }}</div>
                      }
                    </div>
                    <!-- <div *ngIf="is_configurable_item($any(line))"  class="flexcol">
                    <div>
                      {{line.value.data.cufs[C_CUF_CONFIGURATION]}}
                    </div>
                    <div *ngFor="let conf of line.value.data.cufs[C_CUF_CONFIGURATION_VALUE]" >
                      {{conf |json}}
                    </div>
                  </div> -->
                  </td>
                  <td class="colsaleunit" rowspan="2">
                    @if (line.value.packaging_name) {
                      <span style="align-content: center">{{ line.value.packaging_name }}</span>
                    }
                  </td>
                  <td class="colqty">
                    <!-- Qty -->
                    @if (isLineEditable && !is_configurable_line($any(line)) && $any(line).value.typ !== OrderLineType.COMPONENT) {
                      <!-- Qty ne peux etre modifiée uniquement en preparation et pour les articles non configurable  et non plus les enfants des produits configurables -->
                      <ng-container [formGroupName]="i">
                        <!-- [readonly]="formGroup.value.state > 1" retiré : garde MORTE depuis le
                      passage de l'état en enum de chaînes ("CREATED" > 1 => NaN => false).
                      Le @if ci-dessus est la vraie condition. -->
                        <input formControlName="qty" (click)="onClickSelectAll($event)" (blur)="onPriceQtyBlur(i)" (change)="triggerHighlight(i)" [class.userinput]="(lineFlatDiscounts[i] ?? 0) > 0 || (linePercentDiscounts[i] ?? 0) > 0" [class.text-error]="$any(line).value.typ === OrderLineType.ITEM_RETURN" />
                      </ng-container>
                    } @else {
                      <span [class.text-error]="$any(line).value.typ === OrderLineType.ITEM_RETURN">{{ line.value.qty }}</span>
                    }
                  </td>
                  <td class="colcol">
                    <!-- Colisage -->
                    {{ line.value.packaging_qtybaseuom }}
                  </td>
                  @if (true) {
                    <td class="colup">
                      <!-- Unit price -->
                      <span [class.ht-text]="is_ht" [class.ttc-text]="!is_ht">{{ (is_ht ? line.value.uprice_taxx : line.value.uprice_taxi) | fc }}</span>
                      @if (packPriceLabel(line)) {
                        <div class="pack-price-hint">{{ packPriceLabel(line) }}</div>
                      }
                    </td>
                  }
                  @if (true) {
                    <td class="colflatdiscount">
                      <!-- Remise en valeur  -->
                      @if (isLineEditable && $any(line).value.typ !== OrderLineType.COMPONENT) {
                        <input [value]="lineFlatDiscounts[i]" (input)="lineFlatDiscounts[i] = +$any($event.target).value" (click)="onClickSelectAll($event)" (change)="onFlatDiscountChange(i, $event)" [class.userinput]="(lineFlatDiscounts[i] ?? 0) > 0" />
                      } @else {
                        <span>{{ lineFlatDiscounts[i] | fc }}</span>
                      }
                    </td>
                  }
                  @if (true) {
                    <td class="colpercentdiscount">
                      <!-- Remise en pourcentage -->
                      @if (isLineEditable && $any(line).value.typ !== OrderLineType.COMPONENT) {
                        <input [value]="linePercentDiscounts[i]" (input)="linePercentDiscounts[i] = +$any($event.target).value" (click)="onClickSelectAll($event)" (change)="onPercentDiscountChange(i, $event)" [class.userinput]="(linePercentDiscounts[i] ?? 0) > 0" />
                      } @else {
                        <span>{{ linePercentDiscounts[i] }} %</span>
                      }
                    </td>
                  }
                  @if (true) {
                    <td class="colnetprice">
                      <!-- net price -->
                      @if (isLineEditable && $any(line).value.typ !== OrderLineType.COMPONENT) {
                        <ng-container [formGroupName]="i">
                          @if (is_ht) {
                            <input formControlName="unet_taxx" (click)="onClickSelectAll($event)" (input)="onNetChange(i)" [class.userinput]="(lineFlatDiscounts[i] ?? 0) > 0 || (linePercentDiscounts[i] ?? 0) > 0" />
                          } @else {
                            <input formControlName="unet_taxi" (click)="onClickSelectAll($event)" (input)="onNetChange(i)" [class.userinput]="(lineFlatDiscounts[i] ?? 0) > 0 || (linePercentDiscounts[i] ?? 0) > 0" />
                          }
                        </ng-container>
                      } @else {
                        <span>{{ (is_ht ? line.value.unet_taxx : line.value.unet_taxi) | fc }}</span>
                      }
                      @if (packPriceLabel(line)) {
                        <div class="pack-price-hint">{{ packPriceLabel(line) }}</div>
                      }
                    </td>
                  }
                  <!-- <td class="col5"  *ngIf="true">
                {{ line.value.net_taxi }}
              </td>	 -->
                  @if (true) {
                    <td class="colcolnetprice" [class.ht-text]="is_ht" [class.ttc-text]="!is_ht">
                      <!-- Prix net d'une unité de base (le conditionnement l'inclut déjà) -->
                      {{ baseUnitNet(line, !is_ht) | fc }}
                    </td>
                  }
                  <td class="colvat">
                    <!-- VAT Code -->
                    {{ line.value.vat }}
                  </td>
                  <td class="colamounttaxx ht-text" [class.text-error]="$any(line).value.typ === OrderLineType.ITEM_RETURN">
                    <!-- Amount HT = qty × prix net du conditionnement (éco-participation incluse) -->
                    {{ lineAmount(line, false) | fc }}
                  </td>
                  <td class="colamounttaxi ttc-text" [class.text-error]="$any(line).value.typ === OrderLineType.ITEM_RETURN">
                    <!-- Amount TTC -->
                    {{ lineAmount(line, true) | fc }}
                  </td>
                  <td class="coldelete" rowspan="2">
                    <!-- delete -->
                    <!-- <button  *ngIf="line.value.typ !== 5" mat-icon-button color="primary" matTooltip="Supprimer" aria-label="Supprimer" style="padding: 0px; margin-left:6px; max-height: 20px; max-width: 20px;" (click)="deleteLine(line)"><mat-icon style="font-size: 16px; margin-top: -6px; max-height: 20px; max-width: 20px;">delete</mat-icon></button> -->
                    <!-- isLineEditable ajouté : ce bouton n'était gardé que par `typ !== 5`. Il
                restait donc actif sur une pièce reprise, une facture ou une commande
                soldée, et supprimait réellement la ligne du formulaire. -->
                    @if (line.value.typ !== OrderLineType.COMPONENT && isLineEditable) {
                      <button type="button" class="custom-icon-button error" aria-label="Supprimer" style="padding: 0px; margin-left: 6px; max-height: 20px; max-width: 20px" (click)="deleteLine(line)"><mat-icon style="font-size: 16px; max-height: 20px; max-width: 20px">delete</mat-icon></button>
                    }
                  </td>
                </tr>
                <tr class="sppl-info-line">
                  <td colspan="10" class="sppl-info flexcol">
                    <!-- <span>{{line.value.spl}} </span>
                <span>{{line.value.lnk_spl}} </span> -->
                    @if (line.value.spl && line.value.lnk_spl) {
                      <div>Tarif spécial :&nbsp;{{ line.value.lnk_spl.name }},&nbsp;{{ getStrategyName(line.value.lnk_spl.strategy) }}&nbsp;&nbsp;Valeur&nbsp;:&nbsp;{{ line.value.lnk_spl.param }}&nbsp;&nbsp;id&nbsp;:&nbsp;{{ line.value.spl }}</div>
                    }
                    @for (ep of getEcopartLines(line.value); track $index) {
                      <div style="margin-left: 1em">
                        dont éco-participation {{ ep.code }}&nbsp;:&nbsp;
                        <span style="color: black; font-weight: 500">{{ ep.amount | fc }}</span>
                        &nbsp;€&nbsp;{{ is_ht ? 'HT' : 'TTC' }}
                      </div>
                    }
                  </td>
                </tr>
              </tbody>
            }
          }
        </ng-container>
      </table>
    }
  </form>
  @if (!lines || !lines.length) {
    <div class="nolines">Document vide{{ formGroup?.value?.doc_type === DocType.LOCATION ? ' (partie vente)' : '' }}</div>
  } @else {
    <div class="footer bglavander">
      <!-- Footer Sub total zone -->
      <div>
        <div class="nbpackagelabel">
          <span class="weight-500">Nb. Colisage :&nbsp;</span>
          {{ nbpackagings }}
        </div>
        <div class="nbitemslabel">
          <span class="weight-500">Nb. d'articles :&nbsp;</span>
          {{ nbitems }}
        </div>
      </div>
      <!-- VAT ventilation -->
      @if (showVatPanel) {
        <div id="vat" class="vat-table">
          <table>
            <tr>
              <th class="col1">Code</th>
              <th class="col2">Taux</th>
              <th class="col2">Base HT</th>
              <th class="col2">Montant TVA</th>
            </tr>
            @for (t of formGroup.value.tax; track t) {
              <tr>
                <td class="col1">{{ t.tax }}</td>
                <td class="col2">{{ t.rate }}&nbsp;%</td>
                <td class="col2">{{ t.base_amount | fc }}</td>
                <td class="col2">{{ t.tax_amount | fc }}</td>
              </tr>
            }
          </table>
        </div>
      }
      <!-- Totals block -->
      @if (showTotalsBlock) {
        <div class="totals-block">
          <div class="totals-row totals-row--main">
            <span class="weight-500">Total&nbsp;TTC</span>
            <span class="weight-500" id="amount_taxi">{{ formGroup.value.amount_taxi | fc }}&nbsp;€</span>
          </div>
          <div class="totals-row">
            <span>Total&nbsp;HT</span>
            <span>{{ formGroup.value.amount_taxx | fc }}&nbsp;€</span>
          </div>
          <div class="totals-row">
            <span>Total&nbsp;TVA</span>
            <span>{{ formGroup.value.amount_taxi - formGroup.value.amount_taxx | fc }}&nbsp;€</span>
          </div>
          @if (depositInfo; as dep) {
            <div class="totals-row totals-row--deposit">
              <span class="deposit-label">{{ isDepositDeducted ? 'Acompte perçu, déjà déduit' : 'Dont acompte perçu' }}</span>
              <span class="deposit-val">-{{ dep.amount | fc }}&nbsp;€</span>
            </div>
            <div class="totals-row totals-row--solde">
              <span class="weight-500">Solde restant TTC</span>
              <span class="weight-500 solde-val">{{ formGroup.value.amount_taxi - (isDepositDeducted ? 0 : dep.amount || 0) | fc }}&nbsp;€</span>
            </div>
          }
        </div>
      }
      <!-- WTF is that?
    <ng-container *ngIf="formGroup.value.state == SalesOrderState.QUOTE">
      <div class="dulabel">
        <span class="weight-500">Reste dû :</span>
      </div>
      <div class="duamount">{{ remainder | fc }}&nbsp;€</div>
      <div class="changelabel">
        <span class="weight-500">A rendre :</span>
      </div>
      <div class="changeamount">{{ change | fc }}&nbsp;€</div>
    </ng-container>
    -->
    </div>
  }
  @if (isLineEditable) {
    <div class="inputzone bglavander">
      <smart-select [items]="lineTypes" bindValue="value" bindLabel="label" [formControl]="linetype" height="29px" optionHeight="32px" width="220px"></smart-select>
      <app-search-product tabindex="2" #searchProduct width="510px" (blurEmitter)="blurEmitterSearchProduct($event)" (selectProductEmitter)="selectProductEmitter($event)" [is_ht]="is_ht"></app-search-product>
    </div>
  }
  @if (isLineEditable && isNegativeTotal && !is_visible(2)) {
    <div class="negative-draft-banner">
      <div class="negative-draft-info">
        <mat-icon>info</mat-icon>
        <span>
          Total négatif ({{ formGroup.get('amount_taxi')?.value | fc }}&nbsp;€) :
          @if (formGroup?.value?.doc_type === DocType.FACTURE) {
            Une commande à livrer ne peut avoir un montant négatif. Passer un avoir en comptoir
          } @else if (pendingAvoirAction === 'REFUND_CASH') {
            Remboursement espèces
          } @else if (pendingAvoirAction === 'AVOIR_ONLY') {
            Avoir uniquement sélectionné.
          } @else {
            choisissez « Remboursement espèces » ou « Avoir uniquement » dans la barre d'action.
          }
        </span>
      </div>
    </div>
  }
  <!-- Payment zone -->
  <!-- Show payment only after TOTAL  -->
  @if (is_visible(1)) {
    <!-- Receivables Block -->
    <div id="receivablesZone">
      @if (formGroup.value.lnk_receivables; as recs) {
        <!-- First block: Third-party payers (payer_id != customer) -->
        @if (recs.length > 1 || (recs.length === 1 && recs[0].payer_id !== formGroup.value.customer)) {
          <table style="margin-bottom: 1rem">
            <thead>
              <tr>
                <th class="col1">Tiers Payeur</th>
                <th class="col2">A régler</th>
                <th class="col3">Réglé</th>
                <th class="col4">Dû</th>
              </tr>
            </thead>
            <tbody>
              @for (rec of recs; track rec) {
                @if (rec.payer_id !== formGroup.value.customer) {
                  <tr>
                    <td class="col1">{{ rec.payer_id }}</td>
                    <td class="col2">{{ rec.amount_expected | fc }}</td>
                    <td class="col3">{{ rec.amount_paid | fc }}</td>
                    <td class="col4">{{ rec.amount_expected - rec.amount_paid | fc }}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
        <!-- Second block: Customer (payer_id == customer) -->
        @for (rec of recs; track rec; let recIndex = $index) {
          @if (rec.payer_id === formGroup.value.customer) {
            <div class="customer-receivable-block" style="margin-bottom: 1rem">
              <!-- Read-only Payment Table for this Receivable -->
              @if (rec.lnk_receivable_payments?.length) {
                <table>
                  <thead>
                    <tr>
                      <th class="col1">Mode de règl.</th>
                      <th class="col2">Montant</th>
                      <th class="col3">&nbsp;</th>
                      <th class="col4"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (line of rec.lnk_receivable_payments; track line; let lineIndex = $index) {
                      <tr>
                        <td class="col1">{{ map_paymentmethods.get($safeNavigationMigration(line.lnk_payment?.method)) }}</td>
                        <td class="col2" [style.color]="line.amount < 0 ? 'red' : ''"> {{ line.amount | fc }} </td>
                        <td class="col3"> {{ line.lnk_payment?.data?.comment }}</td>
                        <td class="col4" style="text-align: right">
                          <!-- isPaymentCancelable : pièce reprise (historique légal hors chaîne safe), pièce soldée,
                        ou commande (l'acompte s'annule par son avoir). La ligne reste visible, le geste non. -->
                          @if (canCancelPaymentLine(line)) {
                            <button type="button" class="custom-icon-button error" matTooltip="Annuler le règlement" aria-label="Annuler" (click)="onCancelPayment(recIndex, lineIndex)">
                              <mat-icon>delete</mat-icon>
                            </button>
                          }
                          @if (canSubstitutePayment(line)) {
                            <button type="button" class="custom-icon-button primary" matTooltip="Modifier le mode de règlement" aria-label="Modifier le mode de règlement" (click)="onOpenSubstitutePayment(line)">
                              <mat-icon>swap_horiz</mat-icon>
                            </button>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
              <div style="white-space: nowrap">
                @if (remainder > 0) {
                  A régler :&nbsp;
                  <span class="remainder">{{ remainder | fc }}</span>
                }
                @if (remainder === 0) {
                  <span class="success">{{ formGroup.value.doc_type === DocType.AVOIR ? 'Avoir soldé en totalité' : 'Commande Payée en totalité' }}</span>
                }
                @if (remainder < 0) {
                  @if (formGroup.value.doc_type === DocType.AVOIR && formGroup.value.state === SalesOrderState.INVOICED) {
                    <span class="font-semibold" style="color: #0284c7">Solde d'avoir disponible : {{ absRemainder | fc }}&nbsp;€</span>
                  } @else {
                    <span class="font-semibold" style="color: #0284c7">Solde négatif : ({{ remainder | fc }}&nbsp;€)</span>
                  }
                }
              </div>
              <!-- Dynamic patient payment gauge -->
              @if (formGroup.value.doc_type !== DocType.AVOIR) {
                <div class="patient-gauge-box">
                  <div class="gauge-header">
                    <span class="gauge-title">Progression règlement</span>
                    <span class="gauge-percent font-semibold">{{ paymentProgressPercent }}%</span>
                  </div>
                  <div class="gauge-track">
                    <div class="gauge-fill" [style.width.%]="paymentProgressPercent" [class.complete]="remainder === 0"></div>
                  </div>
                  <div class="gauge-legend">
                    <span class="legend-paid">Réglé&nbsp;: {{ payed | fc }}&nbsp;€</span>
                    @if (depositInfo; as dep) {
                      <span class="legend-deposit">Dont acompte&nbsp;: {{ dep.amount | fc }}&nbsp;€</span>
                    }
                    <span class="legend-remainder">Reste&nbsp;: {{ remainder | fc }}&nbsp;€</span>
                  </div>
                </div>
              }
            </div>
          }
        }
      }
    </div>
    <!-- Payment inputs block -->
    <!-- isPaymentEntryVisible : sur une COMMANDE (F2), l'argent n'entre que par « Encaisser un acompte ». -->
    <!-- is_visible(2) et non plus le seul reste à payer : sur un document repris, les créances
  et les règlements ci-dessus sont montrés en LECTURE, mais aucun encaissement n'est
  saisissable (le serveur le refuse — voir la note de is_visible dans le .ts). -->
    @if (is_visible(2) && isPaymentEntryVisible && remainder > 0) {
      <div id="paymentzone">
        <smart-select [items]="paymentMethodItems" bindValue="id" bindLabel="name" [bindDisabled]="isCashLocked" [itemTemplate]="paymentMethodOption" [formControl]="paymenttype" width="200px" height="29px" optionHeight="32px"></smart-select>
        <ng-template #paymentMethodOption let-pm>
          <span [class.cash-locked]="isCashLocked(pm)" [matTooltip]="isCashLocked(pm) ? cashNeedsDrawer : ''">{{ pm.name }}</span>
        </ng-template>
        <input-price [formControl]="paymentinput" (keydown)="onPaymentKeydown($event)" id="paymentinput"></input-price>
        <button type="button" class="custom-filled-button success paymentbutton" matTooltip="Ajouter un règlement" aria-label="Ajouter" id="addPaymentButton" (click)="onPayment()">
          <mat-icon>euro</mat-icon>
          Ajouter
        </button>
        <button type="button" class="custom-filled-button success paymentbutton" matTooltip="Solder le Bon" aria-label="Solder le Bon" (click)="onSellout()">
          <mat-icon>done</mat-icon>
          Solder
        </button>
        <smart-input [formControl]="paymentdataComment" placeholder="Commentaire" width="300px"></smart-input>
      </div>
    }
  }
}
<!-- *ngIf="formGroup" -->
